// extracted by mini-css-extract-plugin
export default {"button-wrapper":"styles_button-wrapper__hVKbH"};